<template>
  <div class="page">
    <img v-for="img in imgList" v-lazy="img" :key="img"/>
  </div>
</template>

<script >
import { cdnresources } from '@/util/config'
export default {
  
  data() {
    return {
      cdnresources,
      imgList:[
        cdnresources+'/prod/images/yueyangbao/jkgl-11.png',
        cdnresources+'/prod/images/yueyangbao/jkgl-12.png',
        cdnresources+'/prod/images/yueyangbao/jkgl-13.png',
        cdnresources+'/prod/images/yueyangbao/jkgl-14.png',
        cdnresources+'/prod/images/yueyangbao/jkgl-15.png',
        cdnresources+'/prod/images/yueyangbao/jkgl-16.png',
        cdnresources+'/prod/images/yueyangbao/jkgl-17.png',
        cdnresources+'/prod/images/yueyangbao/jkgl-18.png',
        cdnresources+'/prod/images/yueyangbao/jkgl-19.png',
      ]
    }
  },
  components: {

  }
}
</script>

<style lang="scss" scoped>
  img{
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
</style>
